var app = angular.module('tf.leaderboard', ['tf.leagues.create', 'tf.leagues.search'])
                 .controller('leaderboardCtrl', leaderboardController);

/** @ngInject */
function leaderboardController($scope, $http, userConfig, $timeout, $interval, leaderBoardService, $uibModal, $stateParams, leagueInviteService) {

    var boardId = $stateParams.board;

    $scope.leaderboardsAsAt = null;
    $scope.overallLeaderboard = null;
    $scope.leaderboards = [];
    $scope.selectedLeague = null;

    $scope.showInvite = false;

    $scope.showInvitingToLeague = () => {
        leagueInviteService.open($scope.selectedLeague)
    };


    $scope.createNewLeague = function () {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/game/partials/leagues/createNewLeague.tpl.html',
            controller: 'createLeagueCtrl',
            backdrop: 'static',
            size: 'lg',
            resolve: {
            }
        });
    };

    $scope.updateLeaderBoard = function () {

        return $http.get('/tradefloor/api/leaderboards?u=' + userConfig.id, {ignoreLoadingBar: true}).then(function (response) {

            if ($scope.leaderboards.length && response.status === 304) {
                return;
            }

            var data = response.data;
            var leaderboards = data.leaderboards;
            $scope.leaderboardsAsAt = data.asAt;

            function addGap(leaderboard) {

                var currentRank = 0;

                var gap = undefined;
                for (var i = 0; i < leaderboard.leaders.length; i++) {
                    var rank = leaderboard.leaders[i].rank;
                    if (currentRank !== rank && rank !== (i + 1)) {
                        gap = i;
                        break;
                    }
                    currentRank = rank;
                }

                if (gap !== undefined) {
                    leaderboard.leaders.splice(gap, 0, {
                        gap: true
                    });
                }
            }

            leaderboards.forEach(addGap);

            var selected;

            if (boardId != null) {
                selected = leaderboards.find(lb => lb.id === boardId)
            } else {
                selected = leaderboards.find(lb => lb.name === "Overall") || leaderboards.find(lb => lb.name === "Professional");
            }

            $scope.leaderboards = leaderboards;

            if (selected != null) {
                $scope.tabChanged(selected);
            }
        });
    };

    $scope.updateLeaderBoard();

    var leaderBoardUpdateInterval = $interval(function () {
        $scope.updateLeaderBoard();
    }, 300000);

    $scope.tabChanged = function (league) {
        $scope.selectedLeague = league;
        boardId = league.id;
        $scope.inviteEmails = [];
    };

    $scope.leaveLeague = async (id) => {
        await leaderBoardService.leaveLeague(id);
        if ($scope.selectedLeague.id === id) {
            $scope.selectedLeague = null;
        }
        $scope.updateLeaderBoard()
    };

    $scope.$on("$destroy", function () {
        $interval.cancel(leaderBoardUpdateInterval)
    });


    $scope.joinLeague = function (league, pin) {
        leaderBoardService.joinLeague(league, pin).then(function() {
            leaderBoardService.viewLeaderBoard();
        });
    };
}
